<template>
  <span ref="loaderEl" :style="dimensions"></span>
</template>

<script setup lang="ts">
import { ref, computed, nextTick, onBeforeUnmount, onMounted } from 'vue';
import lottie from 'lottie-web';

interface Props {
  size?: string;
  name: string;
  path: string;
  pathIsAnimationData?: boolean;
  loop?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: '50px',
  loop: true,
});

const loaderEl = ref<HTMLSpanElement | null>(null);

const dimensions = computed(() => {
  return {
    width: props.size,
    height: props.size,
  };
});

const animation = ref<ReturnType<typeof lottie.loadAnimation> | null>(null);

async function loadAnimation() {
  animation.value?.destroy();
  await nextTick();
  if (loaderEl.value && loaderEl.value.children.length === 0) {
    loaderEl.value.innerHTML = '';
    animation.value = lottie.loadAnimation({
      container: loaderEl.value,
      path: props.pathIsAnimationData ? undefined : props.path,
      animationData: props.pathIsAnimationData
        ? JSON.parse(props.path)
        : undefined,
      renderer: 'svg',
      loop: props.loop,
      autoplay: true,
      name: props.name,
    });
  }
}

onMounted(() => {
  loadAnimation();
});

onBeforeUnmount(() => {
  animation.value?.destroy();
});

defineExpose({
  loadAnimation,
});
</script>
